import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
//@ts-ignore
import MUIDataTable from "mui-datatables";
const HorizontalDataTable = ({ title = "", columns = [], data = [], options = {}, muiTheme = createTheme() }) => {
    return (React.createElement(ThemeProvider, { theme: muiTheme },
        React.createElement(MUIDataTable, { title: title, data: data, columns: columns, options: options })));
};
export default HorizontalDataTable;
